import React from "react";
import { useSelector } from "react-redux";
import GlobalDeleteDialog from "../../components/mui/Dialogue/GlobalDeleteDialog";
import {
  DeletePermissions,
  getallPermissions,
} from "../../redux/features/permissionSlice";

const DeletePermission = ({ id, dispatchdata }) => {
  const { loading } = useSelector((state) => state.permission);
  const { paginationData, openAnchor } = useSelector(
    (state) => state.globalDataGrid
  );

  return (
    <GlobalDeleteDialog
      title={"Delete Permission"}
      deleteNote={"Are you sure? you want to delete this Permission..?"}
      api={DeletePermissions(id)}
      upDateCall={getallPermissions(dispatchdata)}
      loading={loading}
    />
  );
};

export default DeletePermission;
